var render, staticRenderFns
import script from "./baseFormDescuentosTerceros.vue?vue&type=script&lang=js"
export * from "./baseFormDescuentosTerceros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b25f6800')) {
      api.createRecord('b25f6800', component.options)
    } else {
      api.reload('b25f6800', component.options)
    }
    
  }
}
component.options.__file = "src/components/Flujo/Formularios/DescuentoTerceros/baseFormDescuentosTerceros.vue"
export default component.exports